import React from 'react';
import { Tabs } from 'antd';
import { useAppSelector } from '../../hooks/redux';
import { isAdmin, isManager, isSupportUser } from '../../utils/roleHelpers';
import CashRegisterManagement from './CashRegisterManagement';
import AdminAllCashRegistersView from './AdminAllCashRegistersView';

/**
 * "Caja" page. Wraps "Mi Caja" and "Todas las Cajas" in tabs.
 *
 * "Todas las Cajas" is only available to Admin/Gerente (and support users);
 * everyone else sees just "Mi Caja" with no tab bar. This mirrors the previous
 * sidebar gating where the "Todas las Cajas" submenu item was only shown to
 * users with admin access.
 */
const CajaTabs: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  const hasAdminAccess =
    isSupportUser(user?.email) || isAdmin(user?.role) || isManager(user?.role);

  if (!hasAdminAccess) {
    return <CashRegisterManagement />;
  }

  return (
    <Tabs
      defaultActiveKey="my-cash"
      items={[
        {
          key: 'my-cash',
          label: 'Mi Caja',
          children: <CashRegisterManagement />,
        },
        {
          key: 'all-cash',
          label: 'Todas las Cajas',
          children: <AdminAllCashRegistersView />,
        },
      ]}
    />
  );
};

export default CajaTabs;
